export default {
  title: 'Request invoice',
  form: {
    is_receipt_required: {
      label: 'Request invoice via email',
    },
    company_name: {
      placeholder: 'Company name (optional)',
    },
    first_name: {
      placeholder: 'First name',
    },
    last_name: {
      placeholder: 'Last name',
    },
    address: {
      placeholder: 'Street + number',
    },
    zip_code: {
      placeholder: 'Zip code',
    },
    city: {
      placeholder: 'City',
    },
    tax_id: {
      placeholder: 'Tax ID',
    },
    email: {
      placeholder: 'Email address',
    },
  },
};
